import { Link, useParams } from "react-router-dom";
import { AppUsageUsers } from "@/components/Settings/AppUsageUsers";

export function SettingsUsageApp() {
  const { appId } = useParams<{ appId: string }>();

  if (!appId) {
    return (
      <div className="p-6">
        <p className="text-sm text-red-700">Application ID is required.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">
      <div>
        <div className="mb-2 text-sm text-muted-foreground">
          <Link to="/settings" className="hover:underline">
            Settings
          </Link>
          {" / "}
          <Link to="/settings/usage" className="hover:underline">
            Usage
          </Link>
        </div>
        <h1 className="text-3xl font-bold">Application Usage</h1>
        <p className="mt-2 text-muted-foreground">
          View users and their activity within this application.
        </p>
      </div>
      <AppUsageUsers appId={appId} />
    </div>
  );
}
